// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { PriceType } from '@shared/utils/History/CashItemUtils';
import { MAMode } from '../../IndicatorConstants';
import { ExpandDoubleVector } from '../../DoubleMatrix';
import { IndicatorFunctions } from '../../IndicatorFunctions';
import { iBuildInIndicator } from '../../iBuildInIndicator';
export const iBearsPower = 'iBearsPower';
export class IBearsPower extends iBuildInIndicator {
    constructor(maPeriod, priceType) {
        super(1);
        this.FEMA = new ExpandDoubleVector();
        this.FMaPeriod = maPeriod;
        this.FPriceType = priceType;
    }
    get Name() {
        return iBearsPower;
    }
    get Key() {
        return this.DefaultKey + this.FMaPeriod + this.FPriceType;
    }
    Refresh(count, newThread) {
        this.FEMA.Dispose();
        this.FEMA = new ExpandDoubleVector();
        super.Refresh(count, newThread);
    }
    NextBar(callBound) {
        this.FEMA.Add(0.0);
        super.NextBar(callBound);
    }
    OnQuote() {
        const price = this.GetPrice(this.FPriceType, 0);
        this.FEMA[this.FEMA.Length - 1] = price;
        const Parent = this.Parent;
        if (!Parent) {
            return;
        }
        if (this.FMaPeriod > this.Count - 1) {
            return;
        }
        this.SetValue(this.GetPrice(PriceType.Low, 0) -
            IndicatorFunctions.CallMovingFunction(MAMode.EMA, this.FEMA, this.FMaPeriod, 1));
    }
}
